/** @format */

import React from "react";
import { Switch, Route } from "react-router-dom";
import Login from "../layouts/login";
import Register from "../layouts/register";
import ProtectedRoutes from "../layouts/protectedRoutes";
import NoMatch from "../layouts/noMatch";
import Navbar from "../layouts/navbar";
const Routes = () => {
  return (
    <div>
      <Route path="/" component={Navbar} />
      <Switch>
        <Route
          path="/"
          exact
          render={() => (
            <div style={{ background: "#3b6978", height: "90vh" }} className="text-center text-light">
              Click On Teacher's Directory
            </div>
          )}
        />
        <Route path="/home" render={() => <ProtectedRoutes />} />
        <Route path="/register" render={(...props) => <Register {...props} />} />
        <Route path="/login" render={(...props) => <Login {...props}/>} />
        <Route component={NoMatch} />
      </Switch>
    </div>
  );
};
export default Routes;
